<section class="h-screen flex items-center">
  <div class="max-w-lg mx-auto p-4 flex flex-col items-center gap-2 w-full">
    <img
      src="https://superlikers-themes.s3.amazonaws.com/modelo_para_ganar/v4/logo-primario.png"
      alt="Modelo para ganar Logo" />
    <h1 class="font-bold text-lg">¡Bienvenido/a Modelo Para Ganar!</h1>

    <p class="text-balance text-center my-8">Estamos realizando tareas de mantenimiento. Por favor, vuelve a intentarlo más tarde.</p>

    <a
      href="https://wa.me/573138402680"
      target="_blank"
      class="cursor-pointer text-theme-aquamarine flex gap-2 items-center font-light text-sm mt-8 transition-colors duration-300 hover:text-theme-aquamarine/80">
      ¿Necesitas soporte?
      <img
        class="w-8"
        src="https://modeloparaganar.s3.us-east-2.amazonaws.com/layout/ICO_MAIL.png"
        alt="help icon" />
    </a>
  </div>
</section>
